import {
  FaMobileAlt,
  FaTabletAlt,
  FaLaptop,
  FaHeadphones,
  FaCamera,
  FaPlug,
  FaTv,
  FaPrint,
} from "react-icons/fa";
import { RxActivityLog } from "react-icons/rx";

const iconMapping = {
  Smartphone: FaMobileAlt,
  Tablet: FaTabletAlt,
  Laptop: FaLaptop,
  Speaker: FaHeadphones,
  Camera: FaCamera,
  Accessories: RxActivityLog,
  Television: FaTv,
  Printer: FaPrint,
  // Add or modify mappings as needed
};

export default iconMapping;
